import { create } from 'zustand';

interface CalendarState {
  eventsRevision: number;
}

interface CalendarActions {
  bumpEventsRevision: () => void;
  resetState: () => void;
}

type CalendarStore = CalendarState & CalendarActions;

const INITIAL_CALENDAR_STATE: CalendarState = {
  eventsRevision: 0,
};

export const useCalendarStore = create<CalendarStore>((set) => ({
  ...INITIAL_CALENDAR_STATE,
  bumpEventsRevision: () =>
    set((s) => ({ eventsRevision: s.eventsRevision + 1 })),
  resetState: () => set(INITIAL_CALENDAR_STATE),
}));
